import { render, staticRenderFns } from "./ServerViewerChannel.vue?vue&type=template&id=b197ae70&scoped=true"
import script from "./ServerViewerChannel.vue?vue&type=script&lang=js"
export * from "./ServerViewerChannel.vue?vue&type=script&lang=js"
import style0 from "./ServerViewerChannel.vue?vue&type=style&index=0&id=b197ae70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b197ae70",
  null
  
)

export default component.exports